<template>
  <div class="analysis-panel-page col-block" :style="{ height: minHeight || '100%' }">
    <div v-if="datas.length" class="main-container container-block col-block">
      <div class="tab-block">
        <tabButtons
          :state="state"
          :options="tabOptions"
          @change="s => state = s"
        ></tabButtons>
      </div>
      <div class="main-block" :style="{ flex: 1 }">
        <analysisTable
          v-show="state === 'table'"
          :dataType="dataType"
          :country="country"
          :datas="datas"
          :curSelectedDatas="selectedDatas"
          :reportCountrys="reportCountrys || []"
          :state="state"
          :filterOptions="filterOptions"
          :conditions="conditions"
          @allDatas="datas => tableDatas = datas"
          @dataChange="datas => selectedDatas = datas"
        ></analysisTable>
        <analysisGraph
          v-show="state === 'graph'"
          :dataType="dataType"
          :country="country"
          :tableDatas="tableDatas"
          :curSelectedDatas="selectedDatas"
          :state="state"
          :filterOptions="filterOptions"
          :conditions="conditions"
          @dataChange="datas => selectedDatas = datas"
        ></analysisGraph>
        <analysisReport
          v-if="['year'].includes(dataType) && country.hasReport"
          v-show="state === 'report'"
          :dataType="dataType"
          :country="country"
          :state="state"
          :filterOptions="filterOptions"
          :conditions="conditions"
        ></analysisReport>
        <analysisStation
          v-if="['year'].includes(dataType) && (state === 'station' || isComponentLoaded.station)"
          v-show="state === 'station'"
          :dataType="dataType"
          :country="country"
          :state="state"
          :filterOptions="filterOptions"
          :conditions="conditions"
        ></analysisStation>
      </div>
    </div>
    <div v-else-if="['country'].includes(dataType)" class="tutorial-container container-block">
      <analysisTutorial></analysisTutorial>
    </div>
  </div>
</template>

<script>
import analysisTable from '../analysis/table'
import analysisGraph from '../analysis/graph'
import analysisReport from '../analysis/report'
import analysisStation from '../analysis/station'
import analysisTutorial from '../analysis/tutorial'
import tabButtons from '../tool/tabButtons'

export default {
  components: {
    analysisTable,
    analysisGraph,
    analysisReport,
    analysisStation,
    analysisTutorial,
    tabButtons
  },
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: () => null
    },
    minHeight: {
      type: String,
      default: () => null
    },
    datas: {
      type: Array,
      required: true
    },
    tab: {
      type: String,
      default: () => ''
    },
    reportCountrys: {
      type: Array,
      default: () => ([])
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      state: this.tab || 'table',
      tableDatas: [],
      selectedDatas: [],
      isComponentLoaded: {
        station: false
      }
    }
  },
  computed: {
    // static
    tabOptions () {
      return [
        {
          title: '數據結果',
          value: 'table'
        },
        {
          title: '統計圖呈現',
          value: 'graph'
        },
        ...['year'].includes(this.dataType) && this.country.hasReport ? [
          {
            title: '分析報告',
            value: 'report'
          }
        ] : [],
        ...['year'].includes(this.dataType) ? [
          {
            title: '國家概況',
            value: 'station'
          }
        ] : []
      ]
    }
  },
  watch: {
    'state' (nv) {
      this.isComponentLoaded[nv] = true
      this.$emit('changeState', nv)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analysis/panel.vue